import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { MicTestResult, ZoomLauncherService } from '../../../core/services/zoom-launcher.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-zoom-join-modal',
  templateUrl: './zoom-join-modal.component.html',
  styleUrls: ['./zoom-join-modal.component.scss']
})
export class ZoomJoinModalComponent implements OnInit {
  @Input() details: any = {};
  @Input() userId: number;
  @Output() closed = new EventEmitter<void>();

  displayName = '';
  inAppBrowser = this.zoomLauncher.isInAppBrowser();
  pageUrl = window.location.href;
  linkCopied = false;
  showHelp = false;
  micTesting = false;
  micResult: MicTestResult = null;
  platform = this.zoomLauncher.getPlatform();
  browser = this.zoomLauncher.getBrowser();

  constructor(private apiService: ApiService, private zoomLauncher: ZoomLauncherService) { }

  ngOnInit() {
    this.displayName = (this.details && this.details.display_name) || '';
  }

  get isEvent(): boolean {
    return this.details && this.details.meeting_type === 'EVENT';
  }

  join() {
    const name = (this.displayName || '').trim();
    if (!name) {
      return;
    }
    if (this.isEvent) {
      this.zoomLauncher.openInNewTab(this.details.join_url);
      this.close();
      return;
    }
    if (name !== this.details.display_name) {
      this.updateDisplayName(name);
    }
    const zoomName = this.userId ? `${name} (${this.userId})` : name;
    // Zoom's join page lets the browser open the installed app or continue in the browser
    this.zoomLauncher.openInNewTab(this.zoomLauncher.buildJoinUrl(this.details, zoomName));
    this.close();
  }

  testMicrophone() {
    this.micTesting = true;
    this.micResult = null;
    this.zoomLauncher.testMicrophone().then(result => {
      this.micTesting = false;
      this.micResult = result;
    });
  }

  copyPageLink() {
    const done = () => { this.linkCopied = true; };
    const nav: any = navigator;
    if (nav.clipboard && nav.clipboard.writeText) {
      nav.clipboard.writeText(this.pageUrl).then(done, () => { });
    } else {
      const input = document.createElement('textarea');
      input.value = this.pageUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
      done();
    }
  }

  close() {
    this.closed.emit();
  }

  private updateDisplayName(display_name: string) {
    this.apiService.callPostAPI('v2/auth/update-displayname', { display_name }, environment.userApiUrl)
      .subscribe(
        data => {
          this.apiService.successResponse(data);
        }, error => { });
  }
}
